export const buildFormData = (payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    if (key === 'requestDTO' && typeof value === 'object') {
      formData.append(
        'requestDTO',
        new Blob([JSON.stringify(value)], { type: 'application/json' })
      );
    } else if (Array.isArray(value)) {
      value.forEach(item => {
        if (item instanceof File || item instanceof Blob) {
          formData.append(key, item);
        } else {
          formData.append(
            key,
            new Blob([JSON.stringify(item)], {
              type: "application/json",
            })
          );
        }
      });
    } else if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
    } else if (typeof value === 'object') {
      formData.append(
        key,
        new Blob([JSON.stringify(value)], { type: 'application/json' })
      );
    } else {
      formData.append(key, value);
    }
  });

  return formData;
};
